import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import additionalDataFactory from './common/fieldsAdditionalData';
import fieldsContact from './common/fieldsContact';
import {
    fieldsStaircaseSideTurn,
    fieldsStaircaseLimon,
    fieldsStaircasePlainSteps,
    fieldsStaircaseMaterial,
    fieldsStaircaseGuardMaterialComposite,
    fieldsStaircaseLightRamp,
    fieldsStaircaseDimension,
    fieldsStaircaseObstacle,
    fieldsStaircaseMaterialOptional,
    fieldsStepsDimension,
} from './common/fieldsStaircase';

const StaircaseQuaterTurnForm: IForm = {
    formId       : PublishedFormId.StaircaseQuarterTurn,
    type         : FormTypeId.Staircase,
    thumbnailURL : '/resized-images/forms/staircaseQuarterTurn.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.StaircaseSideTurn,
        IFormFieldKey.LimonShape,
        IFormFieldKey.PlainSteps,
        IFormFieldKey.StepsDimension,
        IFormFieldKey.Material,
        IFormFieldKey.StaircaseRailing,
        IFormFieldKey.StaircaseGuard,
        IFormFieldKey.AddOns,
        IFormFieldKey.Dimension,
        IFormFieldKey.Obstacles,
        IFormFieldKey.StaircaseProtection,
        IFormFieldKey.StaircaseLayingStairs,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        staircaseSideTurn: fieldsStaircaseSideTurn,

        limonShape          : fieldsStaircaseLimon,
        plainSteps          : fieldsStaircasePlainSteps,
        stepsDimension      : fieldsStepsDimension,
        material            : fieldsStaircaseMaterial,
        staircaseRailing    : fieldsStaircaseMaterialOptional,
        staircaseGuard      : fieldsStaircaseGuardMaterialComposite,
        addOns              : fieldsStaircaseLightRamp,
        dimension           : fieldsStaircaseDimension,
        obstacles           : fieldsStaircaseObstacle,
        staircaseProtection : {
            value: undefined,
        },
        staircaseLayingStairs: {
            value: undefined,
        },
        additionalData: additionalDataFactory({
            budgetMin          : 3500,
            budgetMax          : 20000,
            budgetDefaultValue : 5800,
            budgetStep         : 500,
            hasQuantity        : false,
        }),
        contact: fieldsContact,
    },
};

export default StaircaseQuaterTurnForm;
